// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BNQ-","label":"styles_label__3INS8"};